var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcKey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 1.5C15.7 1.5 14.66 1.75 13.71 2.22C12.77 2.69 11.95 3.38 11.32 4.23C10.69 5.08 10.27 6.06 10.09 7.1C9.90999 8.14 9.97999 9.2 10.28 10.21L2.48999 18V22.5H6.98999L14.78 14.71C15.71 14.99 16.69 15.07 17.65 14.94C18.61 14.81 19.53 14.47 20.35 13.95C21.17 13.43 21.87 12.74 22.4 11.93C22.93 11.12 23.28 10.2 23.42 9.24C23.56 8.28 23.5 7.3 23.23 6.37C22.96 5.44 22.49 4.58 21.86 3.84C21.23 3.11 20.44 2.52 19.56 2.11C18.68 1.71 17.72 1.5 16.75 1.5ZM16.75 13.5C16.23 13.5 15.72 13.42 15.23 13.27L14.37 13.01L11.35 16.03L10.32 15L9.25999 16.06L10.29 17.09L9.09999 18.28L8.06999 17.25L7.00999 18.31L8.03999 19.34L6.37999 21H3.99999V18.62L11.99 10.63L11.73 9.77C11.41 8.71 11.43 7.58 11.79 6.54C12.15 5.5 12.83 4.59 13.73 3.96C14.63 3.32 15.71 2.99 16.82 3C17.92 3.01 19 3.38 19.88 4.03C20.77 4.69 21.42 5.61 21.76 6.66C22.09 7.71 22.09 8.84 21.74 9.89C21.39 10.94 20.73 11.85 19.83 12.5C18.93 13.15 17.86 13.49 16.75 13.49V13.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9C18.33 9 19 8.33 19 7.5C19 6.67 18.33 6 17.5 6C16.67 6 16 6.67 16 7.5C16 8.33 16.67 9 17.5 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKey);
export default __webpack_public_path__ + "static/media/ic-key.f31fee99f352b07d45afcd2bea919914.svg";
export { ForwardRef as ReactComponent };